import { ContextStore, SerializedData } from 'bernie-core';
import { Logger, SystemEvent, SystemEventLevel } from 'bernie-logger';
import { Store } from 'bernie-core';

import { BentoSource } from 'src/common/sources/bento-source';

import { BentoFeature, BentoModel } from './types';

import { getLayoutByName } from './layout';

import './layouts';

export class BentoStore extends Store {
  protected logger: Logger;

  private configs: { [key: string]: BentoModel } = {};
  private features: BentoFeature[] = [];
  private source: BentoSource = null;

  private contentCollection: { [key: string]: any } = {};

  public constructor(data: SerializedData, logger: Logger, source: BentoSource) {
    super(data, logger);
    this.source = source;
  }

  public getConfig(name: string) {
    const model: BentoModel = this.configs[name];
    const layoutName = model && model.layoutType;
    const layout = layoutName && getLayoutByName(layoutName);
    const hierarchy = model && model.hierarchy;
    const options = (model && model.options) || {};

    return {
      hierarchy,
      layout,
      options
    };
  }

  public isFeatureActive(name: BentoFeature): boolean {
    return this.features.includes(name);
  }

  public hydrate(data: SerializedData) {
    this.deserialiseConfigs(data.configs);
    this.deserialiseFeatures(data.features);
  }

  private deserialiseConfigs(configs: { [key: string]: BentoModel }) {
    Object.values(configs).forEach(config => {
      this.configs[config.name] = {
        ...config,
        options: this.parseOptions(config.options)
      };
    });
  }

  private deserialiseFeatures(features: string[]) {
    if (features) {
      this.features = features
        .map(featureKey => {
          const value = BentoFeature[featureKey];
          if (!value && this.logger) {
            this.logger.logEvent(new SystemEvent(SystemEventLevel.WARN, 'SDUI_FEATURE_DESERIALISE_ERROR'));
          }

          return value;
        })
        .filter(Boolean);
    }
  }

  private parseOptions(options) {
    return Object.keys(options).reduce((obj, key) => {
      try {
        obj[key] = JSON.parse(options[key]);
      } catch {
        obj[key] = options[key];
      }

      return obj;
    }, {});
  }

  public fetch(context: ContextStore) {
    return this.source.fetch(context).then(data => {
      if (!data.error) {
        //TBD: Remove else block once BFF side is updated with new structure ({ features, overrides })
        if (data.features) {
          this.deserialiseConfigs(data.overrides);
          this.deserialiseFeatures(data.features);
        } else {
          this.deserialiseConfigs(data);
        }
      }
    });
  }

  public declareContent(name: string, content: any) {
    this.contentCollection[name] = content;
  }

  public getContent(name: string): any {
    return this.contentCollection[name] || null;
  }
}
